import { enableProdMode, ErrorHandler, APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideNoopAnimations, provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalErrorHandler } from '@common_libraries/helpers/GlobalErrorHandler/global-error-handler';
import { AppInitService } from '@common_libraries/helpers/dynamic_configs/app-init.service';
import { init_app } from './app/app.module';
import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TaNumberPipe } from '@common_libraries/helpers/pipes/taNumberPipe/ta-number-pipe.pipe';
import { ModuleAuth } from '@common_libraries/lib/ModuleAuth';
import { AppRoutingModule } from '@app/app-routing.module';

import { NgxWebstorageModule } from 'ngx-webstorage';



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
          provide: APP_INITIALIZER,
          useFactory: init_app,
          deps: [AppInitService],
          multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideNoopAnimations(),
        provideAnimations(),
        importProvidersFrom(
          AppRoutingModule, 
          BrowserModule, 
          BrowserAnimationsModule,
          NgxWebstorageModule.forRoot(), 
          FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }), 
          ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' })),
          DatePipe,
          DecimalPipe,
          TaNumberPipe,
          ModuleAuth,
          AppInitService
        ]
})
  .catch(err => console.error(err));
